import { render, staticRenderFns } from "./AccountInformationBanner.vue?vue&type=template&id=074ef26d&scoped=true&"
import script from "./AccountInformationBanner.vue?vue&type=script&lang=ts&"
export * from "./AccountInformationBanner.vue?vue&type=script&lang=ts&"
import style0 from "./AccountInformationBanner.vue?vue&type=style&index=0&id=074ef26d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074ef26d",
  null
  
)

export default component.exports